import { IPassportSchemaField } from '@/pages/MDM/mdm.types.ts'
import TrashButton from '@/shared/Buttons/TrashButton'
import FormField from '@/shared/Forms/FormField'
import TextInput from '@/shared/Inputs/TextInput'
import MDMDataTypeDropdown from '@/pages/MDM/components/MDMDataTypeDropdown'
import CreateEntityButton from '@/shared/Buttons/CreateEntityButton'
import MDMValueInput from '@/pages/MDM/components/MDMValueInput'

interface IProps {
  fields: (IPassportSchemaField & { sourceIndex: number })[]
  onFieldChange: (sourceIndex: number, val: any, name: string) => void
  onFieldDelete: (sourceIndex: number) => void
  onFieldCreate: () => void
}

const PassportFieldsForm = (props: IProps) => {
  const renderField = (value: IPassportSchemaField & { sourceIndex: number }, index: number) => {
    return (
      <div className="flex-lines gap16" key={index}>
        <div className="inline-flex-gap width100 flex-space-between">
          <h5 className="text-heading-5">Поле {index + 1}</h5>
          <TrashButton onClick={() => props.onFieldDelete(value.sourceIndex)} />
        </div>
        <FormField label="Наименование" required={true}>
          <TextInput
            value={value.name}
            name="name"
            onChange={(val, name) => props.onFieldChange(value.sourceIndex, val, name)}
            placeHolder="Введите наименование"
          />
        </FormField>
        <FormField label="Тип данных" required={true}>
          <MDMDataTypeDropdown
            value={value}
            onChange={(val) => {
              props.onFieldChange(value.sourceIndex, val.type, 'type')
              props.onFieldChange(value.sourceIndex, val.typeEnumId, 'typeEnumId')
              props.onFieldChange(value.sourceIndex, val.typeUnitId, 'typeUnitId')
            }}
            allowUnit={true}
          />
        </FormField>
        {value.type !== 'ENUM' && value.type !== 'UNIT' && (
          <FormField label="Значение по умолчанию">
            <MDMValueInput
              value={value.defaultValue}
              schema={value}
              name="defaultValue"
              placeHolder="Введите значение по умолчанию"
              onChange={(val, name) => props.onFieldChange(value.sourceIndex, val, name)}
              onUnitValueChange={() => {}}
              onEnumValueChange={() => {}}
            />
          </FormField>
        )}
      </div>
    )
  }

  return (
    <div className="flex-lines gap16" style={{ paddingLeft: '1px' }}>
      {[...props.fields].sort((a, b) => a.orderingIndex - b.orderingIndex).map(renderField)}
      <CreateEntityButton onClick={props.onFieldCreate} text="Добавить значение" type="default" fullWidth={true} />
    </div>
  )
}

export default PassportFieldsForm
